import { createAction } from '@ngrx/store';

const PREFIX = '[Insulation Wizard]';

export const insulationWizardFormSubmitAction = createAction(
  `${PREFIX} Submit form`
);
